module.exports = __webpack_public_path__ + "static/PersonalLoanGirl-d78208daa8b424619e6581cc2adf49ce.jpg";